<template>
    <div :class="['wrapper', classes]">
        <header class="main-header">
            <!-- Header Navbar -->
            <nav
                class="navbar navbar-static-top navbar2"
                role="navigation">
                <!-- Sidebar toggle button-->
                
                <a href="/">
                    <img
                        src="/static/img/back_home_img.png"
                        alt="Logo"
                        class="img-responsive center-block logo"
                        style="width: 300px; height: 42px; margin-top: 20px; background-color: #3c8dbc;" />
                </a>


                <div class="text-center col-md-10 col-md-offset-2" style="margin-top: -60px;">
                    <div class="row">
                        <div class="text-left col-md-8 col-md-offset-2">
                            <ul class="indexSteps">
                                <li class="indexStepLi">{{$i18n.messages[$i18n.locale].indexProduct}}</li>
                                <li class="indexStepLi">{{$i18n.messages[$i18n.locale].indexNews}}</li>
                                <li class="indexStepLi">
                                    <div class="dropdown">
                                        <a data-toggle="dropdown" href="#">{{$i18n.messages[$i18n.locale].indexResource}}</a>
                                        <ul class="resourceSteps dropdown-menu w100" role="menu" aria-labelledby="dLabel">
                                            <li class="resourceStepLi">
                                                {{$i18n.messages[$i18n.locale].indexDoc}}
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li class="indexStepLi">
                                    <a v-bind:href="forumUrl" target="_new">
                                        {{$i18n.messages[$i18n.locale].indexForum}}
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div class="text-right col-md-2" style="margin-top: 10px;">
                            <ul class="nav navbar-nav" style="float: right;">
                                <li class="dropdown messages-menu">
                                    <a
                                        href="javascript:;"
                                        class="dropdown-toggle"
                                        data-toggle="dropdown">
                                        <i class="fa fa-language fa-lg"></i>
                                    </a>
                                    <ul class="dropdown-menu" style="width: 70px; min-width: 70px">
                                        <li>
                                            <!-- inner menu: contains the messages -->
                                            <ul class="menu">
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        @click="$_admin_dash_change_lang('zh-TW')"
                                                    >
                                                        <h4 style="margin: 0 0 0 0">
                                                            tw
                                                            <i
                                                                v-if="$root.$i18n.locale === 'zh-TW'"
                                                                class="fa fa-check label-success"></i>
                                                        </h4>
                                                    </a>
                                                </li>
                                                <li>
                                                    <a
                                                        href="javascript:;"
                                                        @click="$_admin_dash_change_lang('en')"
                                                    >
                                                        <h4 style="margin: 0 0 0 0">
                                                            en
                                                            <i
                                                                v-if="$root.$i18n.locale === 'en'"
                                                                class="fa fa-check label-success"></i>
                                                        </h4>
                                                    </a>
                                                </li>
                                                <!-- end message -->
                                            </ul>
                                            <!-- /.menu -->
                                        </li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>
        </header>

        <!-- Content Wrapper. Contains page content -->
        <div class="content-wrapper" style="min-height: 900px; margin-left: 0px">
            <!-- Content Header (Page header) -->
            <section class="content-header">
                <h1>
                    
                </h1>
            </section>

            <div class="container register-table">
                <div class="row vertical-8p">
                    <div class="container">
                        <div class="row">
                            <div class="text-center col-md-10 col-sm-offset-1">
                                <h1 style="">{{$i18n.messages[$i18n.locale].registerTitle}}</h1>
                            </div>
                        </div>
                        <div class="row">
                            <div class="text-center col-md-10 col-sm-offset-1">
                                <ul class="steps"><li class=""><span>1</span>{{$i18n.messages[$i18n.locale].registerFillInfo}}</li><li class=""><span>2</span>{{$i18n.messages[$i18n.locale].registerComplete}}</li><li class="current"><span>3</span>{{$i18n.messages[$i18n.locale].registerFinish}}</li></ul>
                            </div>
                        </div>
                        
                        <div class="text-center col-md-8 col-sm-offset-2">
                            <h2 style="">{{$i18n.messages[$i18n.locale].registerFinishMessage}}</h2>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- /.content-wrapper -->

        <!-- Main Footer -->
        <footer class="main-footer" style="margin-left: 0px">
            <strong>Copyright &copy; {{year}}
                <a href="javascript:;">NUWA Robotics</a>.</strong> All rights reserved.
        </footer>
    </div>

    
</template>

<script>
    import config from '../config'
    export default {
        name: 'Login',
        data (router) {
            const token = this.$store.state.token && this.$store.state.token !== 'null' ? this.$store.state.token : ''
            let protocol = window.location.protocol
            let env = window.location.hostname.split('.')[0]
            let forumPort = env === 'localhost' ? '4567' : '80'
            let port = env === 'localhost' ? '8060' : '80'
            if (protocol === 'https:') {
                forumPort = '443'
                port = '443'
            }
            env = window.location.hostname
            return {
                section: 'Login',
                token: token,
                loading: '',
                response: '',
                year: new Date().getFullYear(),
                lang: '',
                classes: {
                    fixed_layout: config.fixedLayout,
                    hide_logo: config.hideLogoOnMobile
                },
                forumUrl: protocol + '//' + env + ':' + forumPort + '/forum/',
                gitbookUrl: protocol + '//' + env + ':' + port + '/gitbook/'
            }
        },
        mounted () {
        },
        methods: {
            toggleLoading () {
                this.loading = (this.loading === '') ? 'loading' : ''
            },
            resetResponse () {
                this.response = ''
            },
            $_admin_dash_change_lang (lang) {
                if (lang) {
                    this.$root.$i18n.locale = lang
                    this.lang = lang
                } else {
                    this.$root.$i18n.locale = this.lang
                }
            }
        }
    }
</script>

<style>
    .register-table {
        height: 100%;
    }
    .register-table {
        display: table;
        color: white;
    }
    .register-table h2 {
        color: black;
    }
    .vertical-center-row {
        display: table-cell;
        vertical-align: middle;
    }
    .vertical-20p {
        padding-top: 20%;
    }
    .vertical-10p {
        padding-top: 10%;
    }
    .logo {
        width: 15em;
        padding: 3em;
    }
    .regForm .input-group {
        padding-bottom: 1em;
    }
    .regForm .input-group input, .regForm .input-group select {
        height: 3em;
    }
    .regForm label {
        color: black;
    }
    .regForm .form-group {
        margin-left: -15px;
        margin-right: -15px;
    }
    .control-label {
        padding-top: 7px;
    }
    .margin-top-7px {
        margin-top: 7px;
    }
</style>



// WEBPACK FOOTER //
// UserRegisterComplete.vue?3e0f2667